<template>
    <v-card>
        <v-card-title class="font-weight-light text-h5">
            Choose a username.
            <sub class="d-flex ml-auto">
                <router-link style="text-decoration: none" :to="{ name: 'gallery' }">Not a Creator?</router-link>
            </sub>
        </v-card-title>
        <v-card-subtitle class="mt-n2 ml-2 notice--text">
            <span v-if="signupAttemptWithoutUsername">A username must first be chosen to sign up as a Creator.</span>
        </v-card-subtitle>

        <v-card-text>
            <p class="text-left text-body-2 font-weight-light">
                Please be sure you like your choice as it cannot be changed later. You may use the <i>different</i> button for more options.
            </p>
            <v-list-item dense class="d-flex justify-center text-center" v-for="(username, i)  of usernames" v-bind:key="username">
                <v-list-item-content class="py-0" style="overflow: visible">
                    <v-list-item-title style="overflow: visible">
                        <ts-username :setFirstLoad="setFirstLoad" @chosen="chosenHandler" :index="i" :chosen="chosenUsername" font="allura" :username="username" :delay="(Math.ceil(Math.random() * 3)) * 200"></ts-username>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <v-btn
                   color="primary"
                   text
                   @click="getAvailableUsernames">
                Different
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                   color="primary"
                   text
                   @click="signupButtonHandler">
                Confirm
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<style scoped>
</style>
<script>
import {} from "@mdi/js";
import TsUsername from "./TsUsername.vue";

export default {
    name: "UsernameCard",
    extends: undefined,
    components: {
        TsUsername,
    },
    props: {
        signupAttemptWithoutUsername: Boolean,
    },
    methods: {
        signupButtonHandler: async function () {
            try {
                await this.$auth.loginWithPopup({
                    screen_hint: "signup",
                    appState: { targetUrl: this.$route.fullPath },
                    username_hint: this.chosenUsername,
                });
                this.$router.push({
                    path: "/account#nft-create?welcome=braNFT",
                });
            } catch (error) {
                this.errorMessage = error.message;
                this.error = true;
            }
        },
        chosenHandler: function (username) {
            this.chosenUsername = username;
            this.$emit("input", this.chosenUsername);
        },
        async getAvailableUsernames() {
            this.setFirstLoad = { bool: true };
            this.$set(
                this,
                "usernames",
                await this.$backend.getAvailableUsernames(3)
            );
            this.setFirstLoad = {
                bool: false,
                delay: [
                    "animate__delay-2s",
                    "animate__delay-3s",
                    "animate__delay-4s",
                ],
            };
        },
    },
    data: function () {
        return {
            chosenUsername: null,
            usernames: null,
            overlay: null,
        };
    },
    computed: {
        value() {
            return this.chosenUsername;
        },
    },
    mounted() {
        this.$on("load", function () {
            setTimeout(() => {}, 1000);
        });
    },
};
</script>
